import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useSession } from '../store.js';

export function AppLayout({ children }) {
  const session = useSession();
  const navigate = useNavigate();

  function logout() {
    session.clear();
    navigate('/login', { replace: true });
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/" className="brand">Brand Voice Studio</Link>
        <span style={{ color: 'var(--text-muted)', fontSize: 'var(--type-control)' }}>
          Dashboard
        </span>
        <div className="spacer" />
        <span style={{ color: 'var(--text-muted)', fontSize: 'var(--type-utility)' }}>
          {session.accountId} @ {session.workerUrl?.replace(/^https?:\/\//, '')}
        </span>
        <button className="btn secondary" onClick={logout}>Sign out</button>
      </header>

      <aside className="app-side">
        <NavLink to="/" end>Overview</NavLink>
        <NavLink to="/contacts">Contacts</NavLink>
        <NavLink to="/brands">Brand performance</NavLink>
        <NavLink to="/engines">Engine quality</NavLink>
        <NavLink to="/prompts">Prompt versions</NavLink>
        <NavLink to="/approvals">Approvals</NavLink>
      </aside>

      <main className="app-main">{children}</main>
    </div>
  );
}

export function Stat({ label, value }) {
  return (
    <div className="stat">
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value ?? '—'}</div>
    </div>
  );
}

export function Card({ title, children, action }) {
  return (
    <div className="card">
      {(title || action) && (
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 'var(--space-panel)' }}>
          {title && <div className="card-title" style={{ margin: 0, flex: 1 }}>{title}</div>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function Empty({ children }) {
  return <div className="empty">{children}</div>;
}

export function ErrorBanner({ error }) {
  if (!error) return null;
  return (
    <div className="card" style={{ borderColor: 'rgba(255,107,107,0.4)' }}>
      <div style={{ color: 'var(--danger)' }}>
        {error?.message || String(error)}
      </div>
    </div>
  );
}
